export default {
  penalty: 20,
  showSolution: false,
  hideMap: true,
  undoButton: false,
  legs: [
    {
      imageLocation: '/june/3.jpg',
      scale: '0.50',
      startLocation: [238, 443],
      finishLocation: [236, 173],
      compulsoryPoints: [
        { location: [214, 19], size: 20 },
        { location: [257, 382], size: 25 },
        { location: [249, 275], size: 25 },
        { location: [243, 193], size: 25 },
        { location: [233, 90], size: 25 },
      ],
      disallowedPoints: [
        { location: [38, 126], size: 25 },
        { location: [66, 17], size: 25 },
      ],
      correctPath: [
        [257, 382],
        [244, 147],
        [218, 14],
        [211, 15],
        [228, 83],
        [232, 176],
      ],
    },
    {
      imageLocation: '/june/2.jpg',
      scale: '0.64',
      startLocation: [305, 254],
      finishLocation: [306, 96],
      compulsoryPoints: [],
      disallowedPoints: [
        { location: [111, 155], size: 30 },
        { location: [145, 134], size: 30 },
        { location: [177, 107], size: 30 },
        { location: [215, 115], size: 30 },
        { location: [251, 126], size: 30 },
        { location: [291, 135], size: 30 },
        { location: [326, 135], size: 30 },
        { location: [365, 135], size: 30 },
        { location: [394, 165], size: 30 },
        { location: [418, 198], size: 30 },
        { location: [376, 208], size: 30 },
        { location: [329, 203], size: 30 },
        { location: [289, 192], size: 30 },
        { location: [249, 188], size: 30 },
        { location: [203, 175], size: 30 },
        { location: [161, 166], size: 30 },
      ],
      correctPath: [
        [52, 193],
        [42, 178],
        [54, 151],
        [95, 102],
        [139, 68],
        [197, 46],
        [245, 58],
        [308, 93],
      ],
    },
    {
      imageLocation: '/june/1.jpg',
      scale: '1.00',
      startLocation: [143, 483],
      finishLocation: [140, 137],
      compulsoryPoints: [
        { location: [115, 446], size: 30 },
        { location: [77, 298], size: 50 },
        { location: [83, 201], size: 25 },
        { location: [112, 166], size: 25 },
      ],
      disallowedPoints: [{ location: [181, 434], size: 25 }],
      correctPath: [
        [106, 431],
        [83, 382],
        [71, 224],
        [139, 136],
      ],
    },
    {
      imageLocation: '/june/6.jpg',
      scale: '0.60',
      startLocation: [168, 441],
      finishLocation: [171, 67],
      compulsoryPoints: [
        { location: [258, 247], size: 25 },
        { location: [260, 111], size: 25 },
        { location: [215, 377], size: 25 },
      ],
      disallowedPoints: [{ location: [101, 291], size: 25 }],
      correctPath: [
        [257, 258],
        [252, 231],
        [261, 113],
        [178, 61],
      ],
    },
    {
      imageLocation: '/british/4.png',
      scale: '0.50',
      startLocation: [326, 428],
      finishLocation: [325, 195],
      compulsoryPoints: [
        { location: [450, 392], size: 22 },
        { location: [305, 29], size: 22 },
        { location: [400, 57], size: 22 },
        { location: [254, 144], size: 22 },
      ],
      disallowedPoints: [
        { location: [389, 334], size: 18 },
        { location: [401, 364], size: 18 },
        { location: [314, 462], size: 18 },
        { location: [326, 477], size: 18 },
      ],
      correctPath: [
        [402, 400],
        [446, 389],
        [443, 310],
        [395, 60],
        [303, 27],
        [253, 146],
        [323, 189],
      ],
    },

    {
      imageLocation: '/british/5.png',
      scale: '0.60',
      startLocation: [229, 410],
      finishLocation: [222, 79],
      compulsoryPoints: [
        { location: [300, 375], size: 30 },
        { location: [394, 177], size: 25 },
        { location: [350, 30], size: 25 },
      ],
      disallowedPoints: [
        { location: [186, 365], size: 18 },
        { location: [166, 388], size: 18 },
        { location: [155, 408], size: 18 },
        { location: [32, 148], size: 18 },
      ],
      correctPath: [
        [291, 376],
        [390, 184],
        [401, 41],
        [229, 26],
        [222, 77],
      ],
    },

    {
      imageLocation: '/british/6.png',
      scale: '0.60',
      startLocation: [177, 298],
      finishLocation: [172, 69],
      compulsoryPoints: [
        { location: [201, 323], size: 18 },
        { location: [331, 219], size: 20 },
        { location: [249, 107], size: 22 },
        { location: [190, 128], size: 22 },
      ],
      disallowedPoints: [
        { location: [128, 306], size: 18 },
        { location: [59, 245], size: 18 },
        { location: [254, 186], size: 18 },
      ],
      correctPath: [
        [197, 323],
        [326, 220],
        [244, 109],
        [194, 125],
        [188, 117],
        [173, 71],
      ],
    },

    {
      imageLocation: '/junior/H.png',
      scale: '1.00',
      startLocation: [317, 558],
      finishLocation: [308, 150],
      compulsoryPoints: [
        { location: [291, 216], size: 20 },
        { location: [291, 279], size: 20 },
        { location: [182, 384], size: 20 },
        { location: [200, 490], size: 20 },
        { location: [152, 445], size: 25 },
      ],
      disallowedPoints: [
        { location: [344, 514], size: 20 },
        { location: [256, 456], size: 20 },
        { location: [104, 377], size: 20 },
        { location: [353, 226], size: 20 },
        { location: [346, 82], size: 20 },
      ],
      correctPath: [
        [229, 494],
        [204, 488],
        [136, 428],
        [136, 411],
        [213, 364],
        [319, 249],
        [263, 177],
        [303, 148],
      ],
    },

    {
      imageLocation: '/junior/J.png',
      scale: '1.26',
      startLocation: [214, 393],
      finishLocation: [213, 83],
      compulsoryPoints: [
        { location: [199, 300], size: 20 },
        { location: [155, 153], size: 25 },
        { location: [181, 59], size: 25 },
      ],
      disallowedPoints: [
        { location: [214, 341], size: 15 },
        { location: [226, 340], size: 15 },
        { location: [248, 339], size: 15 },
        { location: [276, 296], size: 25 },
        { location: [278, 372], size: 25 },
        { location: [286, 396], size: 25 },
        { location: [290, 423], size: 25 },
        { location: [293, 87], size: 25 },
        { location: [101, 240], size: 25 },
      ],
      correctPath: [
        [170, 311],
        [198, 302],
        [213, 308],
        [226, 301],
        [199, 241],
        [137, 85],
        [208, 55],
        [212, 80],
      ],
    },

    {
      imageLocation: '/junior/K.png',
      scale: '1.00',
      startLocation: [274, 455],
      finishLocation: [272, 57],
      compulsoryPoints: [
        { location: [206, 422], size: 25 },
        { location: [39, 270], size: 25 },
        { location: [156, 158], size: 25 },
        { location: [220, 104], size: 25 },
      ],
      disallowedPoints: [
        { location: [334, 433], size: 25 },
        { location: [187, 220], size: 25 },
        { location: [289, 114], size: 25 },
      ],
      correctPath: [
        [274, 455],
        [179, 404],
        [46, 301],
        [43, 271],
        [50, 242],
        [204, 123],
        [270, 54],
      ],
    },
  ],
}
